// Page: live-help  (sidebar "who to speak / live for help" sales contact card)
//
// Ported from the inline <script> in
//   Enrollment_modules/sidebar/live-help.module/module.html
//
// Reads the sales contact for the stored utility from the HubDB utility-
// availability table and fills the card (#salesSec-main / .wtslfh-main == root).
//
// DELIBERATE CHANGES (behaviour-preserving):
//   1. HubDB read via core/hubdb `hubdbGetRows('utilityAvailability', …)`
//      instead of an inline api.hubapi.com literal with `window.__ENV__.*`.
//   2. Card field lookups scoped to `root` (were `document.getElementById`).
//   3. BUGFIX: the pagination branch recursed into `getDataFromSessionConfigTable`
//      — a name never defined anywhere (latent ReferenceError once a page of
//      results filled `limit`). It now recurses into the real function.
//   4. Rewritten with async/await (was a .then chain) to match the other Wave 1
//      files, and the carried-over misspelling `saled…`/`utilityIdddd` corrected.
//
// The sibling sidebar/live-help-alt module has no executable JS, so it needs no
// page module.

import { type HubdbRow, hubdbGetRows } from "../../core/hubdb"
import * as storage from "../../core/storage"

export function init(root: HTMLElement): void {
__ea_trace("modules/shared/live-help.ts","init",[root],["root"]);
  const limit = 1000
  let offset = 0
  let allRows: HubdbRow[] = []

  async function getSalesDataFromSessionConfigTable(utilityId: string | null): Promise<void> {
__ea_trace("modules/shared/live-help.ts","getSalesDataFromSessionConfigTable",[utilityId],["utilityId"]);
    try {
      const rows = await hubdbGetRows("utilityAvailability", { limit, offset })
      const matchingRows = rows.filter((row) => row.values[1] === utilityId)
      if (matchingRows.length >= 1) {
        allRows = allRows.concat(matchingRows)
      }
      if (rows.length === limit) {
        // There might be more rows, fetch the next page
        offset += limit
        return getSalesDataFromSessionConfigTable(utilityId)
      }

      const values = allRows[0].values as Record<string, any>
      const salesContactState = values[13]
      const salesContactName = values[34]
      const salesContactTitle = values[35]
      const salesContactEmail = values[36]
      const salesContactPhone = values[37]
      const salesContactBooking = values[38]
      const salesContactImage = values[39]
      const salesContactStateItem = root.querySelector("#salesContactState") as HTMLElement
      const salesContactNameItem = root.querySelector("#salesContactName") as HTMLElement
      const salesContactTitleItem = root.querySelector("#salesContactTitle") as HTMLElement
      const salesContactEmailItem = root.querySelector("#salesContactEmail") as HTMLAnchorElement
      const salesContactPhoneItem = root.querySelector("#salesContactPhone") as HTMLAnchorElement
      const salesContactBookingItem = root.querySelector("#salesContactBooking") as HTMLAnchorElement
      const salesContactImageItem = root.querySelector("#salesContactImage") as HTMLImageElement
      salesContactStateItem.innerText = salesContactState.name
      salesContactNameItem.innerText = salesContactName
      salesContactTitleItem.innerText = salesContactTitle
      salesContactEmailItem.innerText = salesContactEmail
      salesContactEmailItem.href = `mailto:${salesContactEmail}`
      salesContactPhoneItem.innerText = salesContactPhone
      salesContactPhoneItem.href = `tel:${salesContactPhone}`
      salesContactBookingItem.href = salesContactBooking
      if (salesContactImage !== undefined) {
        salesContactImageItem.src = salesContactImage
      }
    } catch (error) {
      console.error("Error fetching data from HubDB:", error)
    }
  }

  getSalesDataFromSessionConfigTable(storage.get("utility_id"))
}
